import { Link, matchPath, useLocation } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import IconBlog from "../SvgIcons/IconBlog";
import IconCalendar from "../SvgIcons/IconCalendar";
import IconCareer from "../SvgIcons/IconCareer";
import IconCV from "../SvgIcons/IconCV";
import IconDashbord from "../SvgIcons/IconDashbord";
import IconExePploads from "../SvgIcons/IconExePploads";
import IconPricing from "../SvgIcons/IconPricing";
import IconTallyAddon from "../SvgIcons/IconTallyAddon";
import IconEnquiry from "../SvgIcons/IconEnquiry";
import ListUsers from "../SvgIcons/ListUsers";
import "./style.css";
import IconConfirmationBy from "../SvgIcons/IconConfirmationBy";

export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation();
  const userType = localStorage.getItem("AdminUser_Type"); // "Admin" or "User"

  const isActive = (paths) =>
    paths.some((path) => matchPath({ path, end: false }, location.pathname));

  // ✅ Menu for Admin (all items)
  const adminMenu = [
    {
      path: "/dashboard",
      icon: <IconDashbord />,
      tooltip: "Dashboard",
      matchPaths: ["/dashboard"],
    },
    {
      path: "/users-list",
      icon: <ListUsers />,
      tooltip: "Users List",
      matchPaths: ["/users-list", "/add-user", "/edit-user/:id"],
    },
     {
      path: "/confirmation-list",
      icon: <IconConfirmationBy/>,
      tooltip: "Event Users List",
      matchPaths: ["/confirmation-list"],
    },
    {
      path: "/blog-view",
      icon: <IconBlog />,
      tooltip: "Blogs Details",
      matchPaths: ["/blog-view", "/add-blog", "/edit-blog/:id"],
    },
    {
      path: "/career",
      icon: <IconCareer />,
      tooltip: "Career Job Post List",
      matchPaths: ["/career", "/edit-career/:id", "/add-career"],
    },
    {
      path: "/JobCandidate",
      icon: <IconCV />,
      tooltip: "View Candidate List",
      matchPaths: ["/JobCandidate"],
    },
    {
      path: "/new-licence",
      icon: <IconPricing />,
      tooltip: "Add New Licence",
      matchPaths: [
        "/new-licence",
        "/edit-new-licence/:id",
        "/renewal-licence",
        "edit-renewal/:id",
      ],
    },
    {
      path: "/tally-addons",
      icon: <IconTallyAddon />,
      tooltip: "Add Tally Addons",
      matchPaths: ["/tally-addons", "/edit-tally-addon/:id", "/add-tally-addons"],
    },
    {
      path: "/exe-uploads",
      icon: <IconExePploads />,
      tooltip: "EXE File Uploads",
      matchPaths: ["/exe-uploads", "/edit-download/:id", "/add-exe-file-upload"],
    },
    {
      path: "/events",
      icon: <IconCalendar />,
      tooltip: "Add New Events",
      matchPaths: ["/events", "/edit-event/:id", "/add-events"],
    },
    {
      path: "/enquiries",
      icon: <IconEnquiry />,
      tooltip: "Customer Enquiry Details",
      matchPaths: ["/enquiries"],
    },
    // {
    //   path: "/event-registration",
    //   icon: <IconEventRegistration/>,
    //   tooltip: "Event Registration",
    //   matchPaths: ["/event-registration"],
    // },
  ];

  // ✅ Menu for User (only blog-related)
  const userMenu = [
    {
      path: "/blog-view",
      icon: <IconBlog />,
      tooltip: "Blogs Details",
      matchPaths: ["/blog-view", "/add-blog", "/edit-blog/:id"],
    },
  ];

  // ✅ Pick correct menu
  const visibleMenuItems = userType === "Admin" ? adminMenu : userMenu;

  return (
    <>
      <div className={`sidebar ${isOpen ? "sidebar-mobile-open" : ""}`}>
        <div className="left-sidemneu">
          <ul>
            {visibleMenuItems.map(({ path, icon, tooltip, matchPaths }) => (
              <li
                key={path}
                className={isActive(matchPaths) ? "active" : ""}
                onClick={onClose}
              >
                <Link to={path} data-tooltip-id={`${tooltip}-tooltip`}>
                  {icon}
                </Link>
                <Tooltip id={`${tooltip}-tooltip`} place="right" content={tooltip} />
              </li>
            ))}
          </ul>
        </div>
      </div>
      {isOpen && (
        <div className="sidebar-overlay" onClick={onClose}></div>
      )}
    </>
  );
}
